import React, { useCallback } from 'react';
import { ButtonTertiary, IconArrowRight, IconDownload, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
const SendOrDownloadButtonStyled = styled(ButtonTertiary) `
  &:active:hover,
  &:hover {
    color: black;
  }
`;
export const SendOrDownloadButton = ({ disabledDownloadButton = false, disabledSendMessageButton = false, state, onDownloadClick, onSendClick, }) => {
    const handleSendMessage = useCallback((ev) => {
        ev === null || ev === void 0 ? void 0 : ev.preventDefault();
        onSendClick === null || onSendClick === void 0 ? void 0 : onSendClick();
    }, [onSendClick]);
    const handleDownloadTranscript = useCallback(ev => {
        ev === null || ev === void 0 ? void 0 : ev.preventDefault();
        onDownloadClick === null || onDownloadClick === void 0 ? void 0 : onDownloadClick();
    }, [onDownloadClick]);
    return state === 'send' ? (React.createElement(SendOrDownloadButtonStyled, { "data-testid": "message-send-button", disabled: disabledSendMessageButton, type: "button", "aria-label": "send message", iconOnly: IconArrowRight, onClick: handleSendMessage })) : (React.createElement(SendOrDownloadButtonStyled, { "data-testid": "download-transcript-button", disabled: disabledDownloadButton, type: "button", "aria-label": "download transcript", iconOnly: IconDownload, onClick: handleDownloadTranscript }));
};
